function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M1142.595,619.442a1.683,1.683,0,0,1,3.145,0l1.138,2.987a5.9,5.9,0,0,0-.418,1.079c-.118.375-.362,1.156-.542,1.156s-.425-.781-.542-1.156c-.253-.809-.515-1.647-1.211-1.647s-.957.837-1.21,1.647c-.118.375-.361,1.156-.542,1.156s-.433-.81-.54-1.156a5.857,5.857,0,0,0-.417-1.079Z",
  transform: "translate(-1130.494 -615.204)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1137.388,637.72a2.443,2.443,0,0,0-2.831-.579,2.093,2.093,0,0,0-.785-.463l2.935-7.705c.037.112.073.226.109.341.253.81.515,1.647,1.209,1.647s.957-.838,1.21-1.647c.118-.375.361-1.156.542-1.156s.425.781.542,1.156c.253.81.515,1.647,1.211,1.647s.957-.837,1.211-1.647c.036-.115.073-.23.11-.343l3.182,8.353a2.429,2.429,0,0,0-1.811-.362,2.092,2.092,0,0,0-3.6-.684,2.028,2.028,0,0,0-.489-.06,2.1,2.1,0,0,0-1.98,1.405A2.054,2.054,0,0,0,1137.388,637.72Z",
  transform: "translate(-1126.106 -620.8)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1122.777,634.215c.253.81.515,1.647,1.209,1.647s.957-.837,1.21-1.647c.118-.375.361-1.156.542-1.156s.425.781.542,1.156a4.428,4.428,0,0,0,.532,1.263l-1.484,3.893a2.025,2.025,0,0,0-.646.121,2.452,2.452,0,0,0-4.317.235c-.046,0-.091,0-.136-.006l2.394-5.984C1122.677,633.893,1122.729,634.058,1122.777,634.215Z",
  transform: "translate(-1118.373 -623.599)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1131,624.335l.815,2.033-1,2.631c-.07-.187-.136-.4-.2-.593-.253-.81-.515-1.647-1.211-1.647s-.959.837-1.212,1.649c-.118.375-.361,1.156-.541,1.156s-.423-.781-.541-1.156a5.063,5.063,0,0,0-.467-1.161l1.164-2.911a1.72,1.72,0,0,1,3.193,0Z",
  transform: "translate(-1122.033 -618)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1119.778,618.714a3.9,3.9,0,1,1,3.777-3.132,2.455,2.455,0,0,0-.275-.021,2.409,2.409,0,0,0-2.246,1.522l-.63,1.576a3.867,3.867,0,0,1-.626.056Z",
  transform: "translate(-1115.914 -611.006)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1117.662,651.848a1.751,1.751,0,1,1,.379-3.459l.311.068.1-.3a1.752,1.752,0,0,1,3.28-.138l.154.365.343-.2a1.385,1.385,0,0,1,1.777.338l.193.24.263-.16a1.742,1.742,0,0,1,2.075.188,2.09,2.09,0,0,0-.414,2.884,1.733,1.733,0,0,1-.75.172Z",
  transform: "translate(-1115.901 -631.528)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1148.467,651.846h-6.656a1.4,1.4,0,0,1-.021-2.8,1.385,1.385,0,0,1,.326.036l.357.079.067-.358a1.391,1.391,0,0,1,1.608-1.134,1.361,1.361,0,0,1,.267.074l.268.1.154-.243a1.391,1.391,0,0,1,2.564.568l.055.437.413-.151a1.746,1.746,0,1,1,.6,3.394Z",
  transform: "translate(-1129.89 -631.527)",
  fill: "#fff"
}));

var SvgMountains = function SvgMountains(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "mountains",
    className: "fill",
    width: 20.304,
    height: 20.321,
    viewBox: "0 0 20.304 20.321",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMountains, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/mountains.217ea080.svg";
export { ForwardRef as ReactComponent };